// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"54e1b57b","453":"b3ca95ca","667":"bda6718d","977":"93082ac0"}[chunkId] + ".chunk.js";
};